import React, { Component } from 'react';
import mainBgImage from './images-sections/bg-pic-recog.jpg';
import './recognitions.css';

export default class Recognition extends Component {
    render() {
        let style = {
            backgroundImage: `url(${mainBgImage})`
        }
        return (
            <div className="recog_page_section" id="recognitions">
                <div style={style} className='recog_section_background'>
                    <div className="recog_content_container">  
                        <div className="recog_headline">Work Smarter</div>
                        <div className="recog_paragraph_01">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod 
                        tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, 
                        quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo 
                        consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse 
                        cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non 
                        proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                        </div>
            
                    </div>   
                </div>             
            </div>
        )
    }
}
